import { orderPaymentMethodComponent } from './created-orders/payment-method/payment-method.component';
import { Routes } from '@angular/router';
import { PropertiesComponent } from './properties/properties.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { OrdersComponent } from './home/orders/orders.component';
import { RevenueComponent } from './home/revenue/revenue.component';
import { CreateOrderComponent } from './create-order/create-order.component';
import { CategoriesComponent } from './create-order/categories/categories.component';
import { ConfirmOrderComponent } from './create-order/confirm-order/confirm-order.component';
import { PaymentMethodComponent } from './create-order/payment-method/payment-method.component';
import { TransferComponent } from './create-order/payment-method/transfer/transfer.component';
import { ReturnItemComponent } from './home/orders/return-item/return-item.component';
import { SelectItemsComponent } from './home/orders/return-item/select-items/select-items.component';
import { ProfileComponent } from './profile/profile.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { CreatedOrdersComponent } from './created-orders/created-orders.component';
import { OrderTransferComponent } from './created-orders/payment-method/transfer/transfer.component';
import { ChatComponent } from './chat/chat.component';
import { authGuard } from './_guard/auth.guard';
import { AddItemsCategoriesComponent } from './created-orders/categories/categories.component';
import { InventoryComponent } from './created-orders/inventory/inventory.component';
import { WalletHistoryComponent } from './wallet-history/wallet-history.component';
import { loginGuard } from './_guard/login.guard';
import { TransactionsComponent } from './transactions/transactions.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'properties',
    component: PropertiesComponent
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [authGuard],
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [authGuard],
  },
 
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'orders',
        component: OrdersComponent
      },

      {
        path: 'revenue',
        component: RevenueComponent
      },
      {
        path: '',
        redirectTo: 'orders',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'orders/:id',
    component: CreatedOrdersComponent,
    canActivate: [authGuard],
  },
  {
    path: 'transactions',
    component: TransactionsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'orders/:id/payment_method',
    component: orderPaymentMethodComponent,
    canActivate: [authGuard],
  },
  {
    path: 'orders/:id/categories',
    component: AddItemsCategoriesComponent
  },
  {
    path: 'orders/:id/categories/:catid/inventories',
    component: InventoryComponent
  },
  {
    path: 'orders/:id/payment_method/transfer',
    component: OrderTransferComponent,
    canActivate: [authGuard],
  },
  {
    path: 'orders/return-item',
    component: ReturnItemComponent,
    canActivate: [authGuard],
  },
  {
    path: 'orders/return-item/:id',
    component: SelectItemsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'chat/:id',
    component: ChatComponent,
    canActivate: [authGuard],
  },
  {
    path: 'create-order',
    component: CreateOrderComponent,
    canActivate: [authGuard],
  },
  {
    path: 'create-order/categories/:catId',
    component: CategoriesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'create-order/confirm',
    component: ConfirmOrderComponent,
    canActivate: [authGuard],
  },

  {
    path: 'create-order/confirm/payment_method',
    component: PaymentMethodComponent,
    canActivate: [authGuard],
  },
  {
    path: 'create-order/confirm/payment_method/transfer',
    component: TransferComponent,
    canActivate: [authGuard],
  },
  {
    path: 'wallet-history',
    component: WalletHistoryComponent,
    canActivate: [authGuard],
  },
];
